"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerSchema = exports.ServerIpStatus = exports.ServerIpType = exports.ServerBootstrapStatus = exports.HelperHealthStatus = exports.HelperAppStatus = exports.ServerStatus = exports.ServerProvider = void 0;
const mongoose_1 = require("mongoose");
var ServerProvider;
(function (ServerProvider) {
    ServerProvider["OVH"] = "ovh";
    ServerProvider["VULTR"] = "vultr";
})(ServerProvider = exports.ServerProvider || (exports.ServerProvider = {}));
var ServerStatus;
(function (ServerStatus) {
    ServerStatus["PROVISIONING"] = "provisioning";
    ServerStatus["ACTIVE"] = "active";
    ServerStatus["ERROR"] = "error";
    ServerStatus["TERMINATED"] = "terminated";
})(ServerStatus = exports.ServerStatus || (exports.ServerStatus = {}));
var HelperAppStatus;
(function (HelperAppStatus) {
    HelperAppStatus["NOT_DEPLOYED"] = "not_deployed";
    HelperAppStatus["DEPLOYING"] = "deploying";
    HelperAppStatus["ACTIVE"] = "active";
    HelperAppStatus["ERROR"] = "error";
})(HelperAppStatus = exports.HelperAppStatus || (exports.HelperAppStatus = {}));
var HelperHealthStatus;
(function (HelperHealthStatus) {
    HelperHealthStatus["UNKNOWN"] = "unknown";
    HelperHealthStatus["HEALTHY"] = "healthy";
    HelperHealthStatus["UNREACHABLE"] = "unreachable";
})(HelperHealthStatus = exports.HelperHealthStatus || (exports.HelperHealthStatus = {}));
var ServerBootstrapStatus;
(function (ServerBootstrapStatus) {
    ServerBootstrapStatus["PENDING"] = "pending";
    ServerBootstrapStatus["BOOTSTRAPPING"] = "bootstrapping";
    ServerBootstrapStatus["READY"] = "ready";
    ServerBootstrapStatus["ERROR"] = "error";
})(ServerBootstrapStatus = exports.ServerBootstrapStatus || (exports.ServerBootstrapStatus = {}));
var ServerIpType;
(function (ServerIpType) {
    ServerIpType["MAIN"] = "main";
    ServerIpType["RESERVED"] = "reserved";
})(ServerIpType = exports.ServerIpType || (exports.ServerIpType = {}));
var ServerIpStatus;
(function (ServerIpStatus) {
    ServerIpStatus["FREE"] = "free";
    ServerIpStatus["ASSIGNED"] = "assigned";
    ServerIpStatus["PROVISIONING"] = "provisioning";
    ServerIpStatus["ERROR"] = "error";
})(ServerIpStatus = exports.ServerIpStatus || (exports.ServerIpStatus = {}));
const ServerIpSchema = new mongoose_1.Schema({
    ip: { type: String, required: true },
    type: { type: String, enum: Object.values(ServerIpType), default: ServerIpType.RESERVED },
    status: { type: String, enum: Object.values(ServerIpStatus), default: ServerIpStatus.FREE },
    providerIpId: { type: String },
    appId: { type: Number },
    domain: { type: String },
    domainId: { type: String },
    sslReady: { type: Boolean, default: false },
}, { _id: false });
exports.ServerSchema = new mongoose_1.Schema({
    provider: { type: String, enum: Object.values(ServerProvider), default: ServerProvider.VULTR },
    providerServerId: { type: String, default: '' },
    ovhServiceId: { type: String, default: '' },
    mainIp: { type: String, default: '' },
    status: { type: String, enum: Object.values(ServerStatus), default: ServerStatus.PROVISIONING },
    hostname: { type: String, default: '' },
    region: { type: String, default: '' },
    plan: { type: String, default: 'vc2-1c-1gb' },
    helperAppStatus: { type: String, enum: Object.values(HelperAppStatus), default: HelperAppStatus.NOT_DEPLOYED },
    helperHealthStatus: { type: String, enum: Object.values(HelperHealthStatus), default: HelperHealthStatus.UNKNOWN },
    helperHost: { type: String, default: '' },
    helperPort: { type: Number, default: 5000 },
    helperSecret: { type: String, default: '' },
    bootstrap: { type: Object, default: { status: ServerBootstrapStatus.PENDING } },
    createdAt: { type: Date, default: Date.now },
    notes: { type: String },
    maxDomainCapacity: { type: Number, default: 16 },
    ips: { type: [ServerIpSchema], default: [] },
});
